<mat-card appearance="outlined">
  <mat-card-header>
    <img matCardAvatar src="assets/images/avatar.jpg">
    <mat-card-subtitle>24 Mins ago</mat-card-subtitle>
    <mat-card-title>Lisa Gill</mat-card-title>
  </mat-card-header>
  <!-- <agm-map mat-card-image [latitude]="lat" [longitude]="lng" [zoom]="zoom"></agm-map> -->
  <google-map [options]="mapOptions"></google-map>
</mat-card>
